const isAdmin = claims => Boolean(
    claims
        && (
            claims.admin === true
            || (Array.isArray(claims.roles) && claims.roles.indexOf('admin') !== -1)
        ),
);

export default isAdmin;
